import { render, staticRenderFns } from "./MarketplaceFaqs.vue?vue&type=template&id=11543f41"
import script from "./MarketplaceFaqs.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketplaceFaqs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports